import {ConnectButton} from "@rainbow-me/rainbowkit";
import {useAccount} from "wagmi";
import {Link, NavLink} from "react-router-dom";
import {RITUAL_CHAIN_ID} from "@/lib/chain";

export function Header() {
  const {chain, isConnected} = useAccount();
  const onRitual = chain?.id === RITUAL_CHAIN_ID;

  return (
    <header className="sticky top-0 z-20 border-b border-forge-border bg-forge-void/80 backdrop-blur">
      <div className="mx-auto flex max-w-[1440px] items-center gap-6 px-6 py-3">
        <Link to="/" className="flex items-center gap-2">
          <img src="/src/assets/logo.svg" alt="Smelt" className="h-8 w-auto" />
        </Link>

        <nav className="hidden md:flex items-center gap-1 text-sm">
          <NavItem to="/">Overview</NavItem>
          <NavItem to="/filings">Filings</NavItem>
          <NavItem to="/console">Console</NavItem>
        </nav>

        <div className="ml-auto flex items-center gap-3">
          {isConnected && (
            <span
              className={`font-mono text-[11px] px-2 py-1 rounded border ${
                onRitual
                  ? "border-success/40 text-success bg-success/5"
                  : "border-danger/40 text-danger bg-danger/5"
              }`}
            >
              {onRitual ? "RITUAL · 1979" : `WRONG · ${chain?.name ?? chain?.id}`}
            </span>
          )}
          <a
            href="https://github.com/adera-coder/smelt"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Smelt on GitHub"
            className="text-forge-slag hover:text-molten-300 transition-colors"
          >
            <GitHubIcon />
          </a>
          <ConnectButton showBalance={false} />
        </div>
      </div>
    </header>
  );
}

function NavItem({to, children}: {to: string; children: React.ReactNode}) {
  return (
    <NavLink
      to={to}
      end={to === "/"}
      className={({isActive}) =>
        `px-3 py-1.5 rounded-md transition-colors ${
          isActive
            ? "text-molten-200 bg-molten-500/10"
            : "text-forge-slag hover:text-forge-ash hover:bg-forge-surface"
        }`
      }
    >
      {children}
    </NavLink>
  );
}

function GitHubIcon() {
  return (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
      <path d="M12 2C6.48 2 2 6.58 2 12.25c0 4.53 2.87 8.37 6.84 9.73.5.1.68-.22.68-.49 0-.24-.01-.88-.01-1.73-2.78.62-3.37-1.37-3.37-1.37-.45-1.18-1.11-1.5-1.11-1.5-.91-.64.07-.62.07-.62 1 .07 1.53 1.06 1.53 1.06.89 1.56 2.34 1.11 2.91.85.09-.66.35-1.11.63-1.37-2.22-.26-4.56-1.14-4.56-5.07 0-1.12.39-2.03 1.03-2.75-.1-.26-.45-1.3.1-2.7 0 0 .84-.28 2.75 1.05A9.36 9.36 0 0 1 12 6.84c.85 0 1.71.12 2.51.34 1.91-1.33 2.75-1.05 2.75-1.05.55 1.4.2 2.44.1 2.7.64.72 1.03 1.63 1.03 2.75 0 3.94-2.34 4.81-4.57 5.06.36.32.68.94.68 1.9 0 1.37-.01 2.47-.01 2.81 0 .27.18.6.69.49A10.02 10.02 0 0 0 22 12.25C22 6.58 17.52 2 12 2Z" />
    </svg>
  );
}
